var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4406 5.40004C22.4558 5.62043 22.4558 5.84083 22.4558 6.06325C22.4558 12.8406 17.2964 20.657 7.86208 20.657V20.6529C5.07516 20.657 2.34613 19.8587 0 18.3535C0.405241 18.4023 0.812513 18.4266 1.2208 18.4277C3.53037 18.4297 5.77392 17.6548 7.5909 16.2278C5.3961 16.1861 3.47146 14.7551 2.79911 12.6659C3.56795 12.8142 4.36015 12.7837 5.11477 12.5776C2.72192 12.0941 1.00041 9.99175 1.00041 7.55015V7.48515C1.71339 7.88226 2.51168 8.10266 3.32826 8.12703C1.07455 6.62084 0.37985 3.62267 1.74081 1.27857C4.34491 4.48291 8.18708 6.43091 12.3116 6.63709C11.8982 4.85565 12.4629 2.98891 13.7955 1.73662C15.8613 -0.205284 19.1103 -0.105751 21.0522 1.95905C22.2009 1.73256 23.3018 1.31107 24.3094 0.713871C23.9265 1.90116 23.1251 2.90969 22.0546 3.55056C23.0713 3.43071 24.0646 3.15852 25 2.74312C24.3114 3.77501 23.444 4.67385 22.4406 5.40004Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2b5c8ef3dbb7b48bb0bb98181e20f6ef.svg";
export { ForwardRef as ReactComponent };